import { render, staticRenderFns } from "./evaluation.vue?vue&type=template&id=4a3b878e&scoped=true&"
import script from "./evaluation.vue?vue&type=script&lang=js&"
export * from "./evaluation.vue?vue&type=script&lang=js&"
import style0 from "./evaluation.vue?vue&type=style&index=0&id=4a3b878e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b878e",
  null
  
)

export default component.exports